import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Sidebar from '../components/Sidebar';
import {menuToggle, setMapStyle, searchLocation, filterMap, setCategory, setActiveFilter, setDirection} from '../actions';

const mapStateToProps = (state) => {
        return{
        geoData : state.mapData,
        map : state.map,
        menu : state.menu,
        mapStyle : state.mapStyle,
        searchQuery : state.searchQuery,
        visibleData : state.visibleData,
        mapCategory : state.places,
        activeFilter : state.activeFilter,
        mapDirection : state.mapDirection
    }
}

const mapDispatchToProps = (dispatch) => {
    return{
        menuToggle : bindActionCreators(menuToggle , dispatch),
        setMapStyle : bindActionCreators(setMapStyle , dispatch),
        searchLocation : bindActionCreators(searchLocation , dispatch),
        filterMap : bindActionCreators(filterMap , dispatch),
        setCategory : bindActionCreators(setCategory , dispatch),
        setActiveFilter : bindActionCreators(setActiveFilter , dispatch),
        setDirection : bindActionCreators(setDirection , dispatch)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/containers/Sidebar.js